import React, { Component, ReactNode } from 'react';
import { RootState, store } from '../../redux/store';
import { changeCurrentComponent, toggleHamburgerMenu } from '../../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import FolderService from '../../service/FolderService';
import ComponentName from 'constant/ComponentName';
import IntegrationMenu from './IntegrationMenu';
import WatchlistMenu from './WatchlistMenu';
import OrchestrationMenu from './OrchestrationMenu';
import { SidebarMenuItemProps } from './SidebarMenuItem';
import SettingsMenu from './SettingsMenu';
import CraMenu from "./CraMenu";
import EnvironmentUtil from "../../util/EnvironmentUtil";
import {InstanceContainer} from "../../config/binding/InstanceBinding";
import Injectables from "../../constant/Injectables";

class SidebarMenu extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  public render(): ReactNode {
    const {
      component: { module },
      user,
    } = this.props;
    const isFraudOrAml = module.includes('fraud') || module.includes('aml');
    const isKyc = module.includes('kyc');
    return (
      <div id={'sidebar'} className={'flex flex-col w-full h-full  items-between justify-between px-4 py-4 gap-y-4'}>
        {isFraudOrAml && <IntegrationMenu goPage={this.goPage} />}
        {isKyc && user.activeRiskType == 'compliance' && <WatchlistMenu goPage={this.goPage} />}
        {this.environmentUtil.getCra() && <CraMenu goPage={this.goPage}/>}
        {isFraudOrAml && <OrchestrationMenu goPage={this.goPage} />}
        <SettingsMenu goPage={this.goPage} />
      </div>
    );
  }

  private goPage = async (m: SidebarMenuItemProps) => {
    const {
      router: { location },
      toggleHamburgerMenu,
      changeCurrentComponent,
    } = this.props;
    const withoutFolders = [
      ComponentName.DASHBOARD,
      ComponentName.CASE,
      ComponentName.ENTITY,
      ComponentName.WATCHLIST,
      ComponentName.CUSTOM_LIST,
      ComponentName.WATCHLIST_ALERT,
      ComponentName.GRAPH,
      ComponentName.CHART,
      ComponentName.POLICY,
      ComponentName.ACH
    ];
    document.title = 'Riskoffice - ' + m.name;
    if (location.pathname.slice(1) == m.path) {
      return;
    }
    changeCurrentComponent(m.component);
    toggleHamburgerMenu(false);
    if (withoutFolders.includes(m.component)) {
      await FolderService.calculate('WITHOUT_FOLDER', m.component, location.pathname, store.getState().page);
      return;
    }
    //Same path
    if (location.pathname.startsWith(`/${m.path}`)) {
      await FolderService.calculate("CONTAINER", m.component, location.pathname, store.getState().page);
      return;
    }
    //Other
    await FolderService.calculate('WITHOUT_FOLDER', m.component, location.pathname, store.getState().page);
  };
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  page: state.page,
  component: state.component,
  user: state.auth.user,
});
const mapDispatchToProps = {
  changeCurrentComponent,
  toggleHamburgerMenu,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(SidebarMenu));
